import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const Footer = ({ brand }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <MKBox
      position="absolute"
      bottom={0}
      left={0}
      width={isSmallScreen ? "100%" : "40%"}
      bgcolor="transparent"
      color="black"
      display="flex"
      justifyContent="center"
      alignItems="center"
      py={2}
      zIndex={1}
      sx={{
        textAlign: "center",
        px: 2,
      }}
    >
      <MKTypography variant="body2" color="dark">
        Copyright © {new Date().getFullYear()} {brand}
      </MKTypography>
    </MKBox>
  );
};

export default Footer;
